export function getStepTitle(step: number) {
  switch (step) {
    case 2:
      return 'Configure Assignments';
    default:
      return 'Select Your Crew';
  }
}
